"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValues = void 0;
var defaultValues = exports.defaultValues = {
  haveEmployerPlan: "don't have",
  planningIndicator: 'plan',
  inflationRate: '2',
  interestRate: '4',
  salaryGrowthRate: '2',
  taxRate: '25',
  percentOfExpenses: '100',
  percentOfIncomeCovered: '60',
  monthlyCap: '10,000',
  mutualFundsStocksSavings: '0',
  numOfYearsCovered: '2',
  otherAnnualIncome: '0',
  otherIncomeCovered: 'No',
  retirementAge: '67',
  retirementSavings: '0',
  yearsToCover: '4'
};